import type { Theme } from '@ksyos/design-system';
import { useTheme } from 'styled-components';

export interface EmptyFolderIconProps extends React.SVGAttributes<SVGElement> {
    size?: number | string;
}

export function EmptyFolderIcon({ size = 80, ...props }: EmptyFolderIconProps) {
    const theme = useTheme() as Theme;

    return (
        <svg
            height={size}
            viewBox="0 0 182 182"
            width={size}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g
                fill="none"
                fillRule="evenodd"
            >
                <circle
                    cx="91"
                    cy="91"
                    fill="#F6F5F4"
                    r="91"
                />
                <path
                    d="M45.048 126.279 34.913 59.244a6 6 0 0 1 5.14-6.844l26.755-3.562a8 8 0 0 1 7.212 2.82l1.063 1.281a12.967 12.967 0 0 0 9.977 4.685h30.306a8 8 0 0 1 6.242 2.996l5.176 6.458-64.69 6.326-9.113 55.464-7.933-2.59Z"
                    fill={theme.colors.neutral300}
                />
                <path
                    d="M45.048 124.004c0-1.72 2.885-17.436 8.654-47.147a13 13 0 0 1 12.762-10.522h80.45a6 6 0 0 1 5.946 6.803l-6.99 51.798a7 7 0 0 1-6.937 6.064H52.044a6.996 6.996 0 0 1-6.996-6.996Z"
                    fill="#EAE6E4"
                />
                <path
                    d="M69.837 61.25c-1.997-.427-4.014.315-6.051 2.225-1.137 1.065-2.044 2.618-2.72 4.658 1.853-.907 3.334-1.455 4.443-1.643 1.11-.188 2.962-.21 5.558-.065"
                    fill={theme.colors.neutral400}
                />
                <path
                    d="M66.304 61.894c.988 0 1.72.173 2.197.519.714.519 2.05.418 2.682 18.966.397 11.634.204 23.592-.579 35.872a1 1 0 0 0 1.637.833l5.648-4.691 5.797 4.831a1 1 0 0 0 1.64-.758c.255-24.667.248-39.418-.022-44.252-.229-4.106-1.012-7.598-2.35-10.477A3 3 0 0 0 80.235 61h-9.88c-1.399 0-2.78.305-4.05.894Z"
                    fill={theme.colors.white}
                />
                <path
                    d="M77 98h3v9h-3z"
                    fill={theme.colors.neutral300}
                />
                <path
                    d="M83 101v3h-9v-3z"
                    fill={theme.colors.neutral300}
                />
            </g>
        </svg>
    );
}
